import { render, staticRenderFns } from "./AnalysesUploadSection.vue?vue&type=template&id=678c6141&scoped=true&"
import script from "./AnalysesUploadSection.vue?vue&type=script&lang=js&"
export * from "./AnalysesUploadSection.vue?vue&type=script&lang=js&"
import style0 from "./AnalysesUploadSection.vue?vue&type=style&index=0&id=678c6141&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678c6141",
  null
  
)

export default component.exports